// 06:00 UK on 29 October until the end of 13 December UK. Both fall in GMT, so UTC is
// UK time. The end is exclusive.
const CHRISTMAS_CAMPAIGN_START = new Date('2026-10-29T06:00:00Z');
const CHRISTMAS_CAMPAIGN_END = new Date('2026-12-26T00:00:00Z');

export const isChristmasCampaignPeriod = (now: Date) =>
  now >= CHRISTMAS_CAMPAIGN_START && now < CHRISTMAS_CAMPAIGN_END;
